import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {environment} from "../../../../environments/environment";
import {HttpService} from "../../../services/http.service";

@Component({
  selector: 'app-ai-title-cell-renderer',
  templateUrl: './ai-title-cell-renderer.component.html',
  styleUrls: ['./ai-title-cell-renderer.component.scss']
})
export class AiTitleCellRendererComponent implements ICellRendererAngularComp {
  private params!: ICellRendererParams;
  public value: any = '';
  public pending: boolean = false;
  public activeBtn: boolean = false;
  constructor(
    private httpService: HttpService,
  ) {
    this.activeBtn = window.location.pathname === '/grid';
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = this.params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  getTitle() {
    this.httpService.post(environment.API_PATH + '/ai/getAiTitleBySingleProduct', {
      product_id: this.params.data.product_id
    }).subscribe(response => {
      console.log('getTitle', response)
    });
  }
}
